import React, { useContext, useEffect, useState } from "react";
import SpareSalesFilter from "./SapreSalesFilter";
import {
  getSparesCount,
  getPartQtyNo,
  getlubsQtyNo,
  stateGraphValues,
  totalOtherAmountCount,
  totalPartAmountCount,
  totalLubsAmountCount,
  monthWiseGraphValues,
  channelPartnerGraphValues,
  dealerStateTableValues,
  monthWiseTableValues,
  channelPartnerWiseTableValues,
} from "./SpareSalesKpi";
import { FilterContext } from "../../context/Filter";
import Vehiclepagecard from "../../components/Cards/Vehiclepagecard";
import Group from "../../assets/images/Group.svg";
import VehiclePagecard4 from "../../components/Cards/VehiclePagecard4";
import WorldMap from "../../components/Maps/Vehiclemap";
import Jcline from "../../components/Graphs/LineGraph/Jcline";
import BarChart from "../../components/Graphs/BarGraph/sparesbar";
import SpareSalesTableCard from "../../components/Cards/SpareSalesTableCard";
import SpareSalesStateWiseTable from "../../components/Table/SpareSalesStateWiseTable";
import SpareSalesMonthWiseTable from "../../components/Table/SpareSalesMonthWiseTable";
import SpareSalesChannelPartnerTable from "../../components/Table/SpareSalesChannelPartnerTable";
import SpareSalesDetailedView from "./SpareSalesDetailedView";
import { TbFilterDown } from "react-icons/tb";
import Sparescard from "../../components/Cards/Sparescard";
import Header from "../../components/Header/Header";
import NavButtons from "../../components/NevBar/NavButtons";
import Spareline from "../../components/Graphs/LineGraph/Spareline";
import PieSpare from "../../components/Graphs/BarGraph/sparepie";
import SpareMap from "../../components/Maps/Sparemap";
import SpareSalesMonthWiseBarLineGraph from "../../components/Graphs/SpareSalesMonthWiseBarLineGraph";
import WaterMark from "../../components/WaterMark";

const SpareIndex = () => {
  const {
    arn: parArn,
    childArn,
    spareSalesPayload,
    isFilterReady,
    isSpOpen,
    setIsSpOpen,
  } = useContext(FilterContext);

  const shouldEnableQuery = Boolean(parArn || childArn);
  const [loading, setLoading] = useState(true);
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  const [spareCount, setSpareCount] = useState(null);
  const [partQty, setPartQty] = useState(null);
  const [lubsQty, setLubsQuty] = useState(null);
  const [totalOtherAmount, setTotalOtherAmount] = useState(null);
  const [totalPartAmount, setTotalPartAmount] = useState(null);
  const [totalLubsAmount, setTotalLubsAmount] = useState(null);
  const [stateGraphData, setStateGraphData] = useState(null);
  const [monthWiseLineGraph, setMonthWiseLineGraph] = useState(null);
  const [channelPartnerGraph, setChannelPartnerGraph] = useState(null);
  const [stateWiseTableData, setStateWiseTableData] = useState(null);
  const [monthWiseTableData, setMonthWiseTableData] = useState(null);
  const [channelPartnerTableData, setChannelPartnerTableData] = useState(null);
  const handleDropDownChange = () => {
    setIsDropDownOpen((prev) => !prev);
  };

  const { search_type, dropDownValue, ...sanitizedPayload } =
    spareSalesPayload || {};

  const refetchAllSpareData = async () => {
    if (!shouldEnableQuery) return;
    setLoading(true);
    try {
      const [
        sparesResp,
        partResp,
        lubsResp,
        totalOtherAmountResp,
        totalPartAmountResp,
        totalLubsAmountResp,
        stateGraphResp,
        monthWiseGraphResp,
        channelPartnerGraphResp,
        stateWiseTableResp,
        mothWiseTableResp,
        channelPartnerWiseTableResp,
      ] = await Promise.all([
        getSparesCount(parArn, childArn, sanitizedPayload),
        getPartQtyNo(parArn, childArn, sanitizedPayload),
        getlubsQtyNo(parArn, childArn, sanitizedPayload),
        totalOtherAmountCount(parArn, childArn, sanitizedPayload),
        totalPartAmountCount(parArn, childArn, sanitizedPayload),
        totalLubsAmountCount(parArn, childArn, sanitizedPayload),
        stateGraphValues(parArn, childArn, sanitizedPayload),
        monthWiseGraphValues(parArn, childArn, sanitizedPayload),
        channelPartnerGraphValues(parArn, childArn, sanitizedPayload),
        dealerStateTableValues(parArn, childArn, sanitizedPayload),
        monthWiseTableValues(parArn, childArn, sanitizedPayload),
        channelPartnerWiseTableValues(parArn, childArn, sanitizedPayload),
      ]);

      setSpareCount(sparesResp || {});
      setPartQty(partResp || {});
      setLubsQuty(lubsResp || {});
      setTotalOtherAmount(totalOtherAmountResp || {});
      setTotalPartAmount(totalPartAmountResp || {});
      setTotalLubsAmount(totalLubsAmountResp || {});
      setStateGraphData(stateGraphResp || {});
      setMonthWiseLineGraph(monthWiseGraphResp || {});
      setChannelPartnerGraph(channelPartnerGraphResp || {});
      setStateWiseTableData(stateWiseTableResp || {});
      setMonthWiseTableData(mothWiseTableResp || {});
      setChannelPartnerTableData(channelPartnerWiseTableResp || {});
    } catch (error) {
      console.error("Error fetching spare data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isFilterReady) return;
    refetchAllSpareData();
  }, [isFilterReady, parArn, childArn, spareSalesPayload]);

  if (!isFilterReady || loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-xl font-semibold">Loading spare data...</div>
      </div>
    );
  }

  return (
    <div>
      <WaterMark />
      <Header heading={"Spares"} />
      <div className="p-2 sm:p-6">
        {isDropDownOpen && (
          <div className="mb-6">
            <SpareSalesFilter />
          </div>
        )}

        <div className=" block md:flex justify-center justify-items-center gap-2 mb-1 ml-3  ">
          <Sparescard
            heading="Unique Part No."
            heading2="Other Amount"
            value={spareCount?.value ?? "N/A"}
            value2={
              totalOtherAmount?.value != null
                ? `₹ ${(totalOtherAmount.value / 100000).toFixed(2)} L`
                : "N/A"
            }
            logo={Group}
          />
          <Sparescard
            heading="Part Qty"
            heading2="Parts Amount"
            value={partQty?.value != null ? Math.round(partQty.value) : "N/A"}
            value2={
              totalPartAmount?.value != null
                ? `₹ ${(totalPartAmount.value / 100000).toFixed(2)} L`
                : "N/A"
            }
            logo={Group}
          />
          <Sparescard
            heading="Lubs Qty"
            heading2="Lubs Amount"
            value={lubsQty?.value != null ? Math.round(lubsQty?.value) : "N/A"}
            value2={
              totalLubsAmount?.value != null
                ? `₹ ${(totalLubsAmount.value / 100000).toFixed(2)} L`
                : "N/A"
            }
            logo={Group}
          />
          {/* <div className="bg-blue-400 text-white p-2 w-10 rounded-md hover:bg-blue-500">
          <TbFilterDown size={20} />
        </div> */}
          <button
            className="bg-[#087FC3] p-2  mt-7 text-white rounded-md h-10 w-10"
            onClick={handleDropDownChange}
          >
            <TbFilterDown size={24} />
          </button>
        </div>

        {/* Graph Cards - Stacks on small screens, row on medium and up */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 mb-2">
          <VehiclePagecard4
            heading={"State-Wise Total Amount"}
            des={<SpareMap data={stateGraphData} />}
          />
          <VehiclePagecard4
            heading={"Month Wise Unique Part Count and Total Amount"}
            des={<SpareSalesMonthWiseBarLineGraph data={monthWiseLineGraph} />}
          />
          <VehiclePagecard4
            heading={"Channel Partner Wise Unique Part Number Count"}
            des={<PieSpare data={channelPartnerGraph} />}
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 mb-3">
          <SpareSalesTableCard
            title={"State wise Total Amount"}
            children={<SpareSalesStateWiseTable data={stateWiseTableData} />}
          />
          <SpareSalesTableCard
            title={"Month Wise Unique Part Count and Total Amount"}
            children={<SpareSalesMonthWiseTable data={monthWiseTableData} />}
          />
          <SpareSalesTableCard
            title={"Channel Partner Wise Unique Part Number Count"}
            children={
              <SpareSalesChannelPartnerTable data={channelPartnerTableData} />
            }
          />
        </div>

        <div className="">
          <SpareSalesDetailedView />
        </div>
      </div>
      <NavButtons />
    </div>
  );
};

export default SpareIndex;
